module.exports = __webpack_public_path__ + "static/media/q1.7d3a070a.md";